/* @generated */
// prettier-ignore
if (Intl.RelativeTimeFormat && typeof Intl.RelativeTimeFormat.__addLocaleData === 'function') {
  Intl.RelativeTimeFormat.__addLocaleData({
    "data": {
      "day": {
        "-1": "dün",
        "-2": "evvelsi gün",
        "0": "bugün",
        "1": "yarın",
        "2": "öbür gün",
        "future": {
          "one": "{0} gün sonra",
          "other": "{0} gün sonra"
        },
        "past": {
          "one": "{0} gün önce",
          "other": "{0} gün önce"
        }
      },
      "day-narrow": {
        "-1": "dün",
        "-2": "evvelsi gün",
        "0": "bugün",
        "1": "yarın",
        "2": "öbür gün",
        "future": {
          "one": "{0} gün sonra",
          "other": "{0} gün sonra"
        },
        "past": {
          "one": "{0} gün önce",
          "other": "{0} gün önce"
        }
      },
      "day-short": {
        "-1": "dün",
        "-2": "evvelsi gün",
        "0": "bugün",
        "1": "yarın",
        "2": "öbür gün",
        "future": {
          "one": "{0} gün sonra",
          "other": "{0} gün sonra"
        },
        "past": {
          "one": "{0} gün önce",
          "other": "{0} gün önce"
        }
      },
      "hour": {
        "0": "bu saat",
        "future": {
          "one": "{0} saat sonra",
          "other": "{0} saat sonra"
        },
        "past": {
          "one": "{0} saat önce",
          "other": "{0} saat önce"
        }
      },
      "hour-narrow": {
        "0": "bu saat",
        "future": {
          "one": "{0} sa. sonra",
          "other": "{0} sa. sonra"
        },
        "past": {
          "one": "{0} sa. önce",
          "other": "{0} sa. önce"
        }
      },
      "hour-short": {
        "0": "bu saat",
        "future": {
          "one": "{0} sa. sonra",
          "other": "{0} sa. sonra"
        },
        "past": {
          "one": "{0} sa. önce",
          "other": "{0} sa. önce"
        }
      },
      "minute": {
        "0": "bu dakika",
        "future": {
          "one": "{0} dakika sonra",
          "other": "{0} dakika sonra"
        },
        "past": {
          "one": "{0} dakika önce",
          "other": "{0} dakika önce"
        }
      },
      "minute-narrow": {
        "0": "bu dakika",
        "future": {
          "one": "{0} dk. sonra",
          "other": "{0} dk. sonra"
        },
        "past": {
          "one": "{0} dk. önce",
          "other": "{0} dk. önce"
        }
      },
      "minute-short": {
        "0": "bu dakika",
        "future": {
          "one": "{0} dk. sonra",
          "other": "{0} dk. sonra"
        },
        "past": {
          "one": "{0} dk. önce",
          "other": "{0} dk. önce"
        }
      },
      "month": {
        "-1": "geçen ay",
        "0": "bu ay",
        "1": "gelecek ay",
        "future": {
          "one": "{0} ay sonra",
          "other": "{0} ay sonra"
        },
        "past": {
          "one": "{0} ay önce",
          "other": "{0} ay önce"
        }
      },
      "month-narrow": {
        "-1": "geçen ay",
        "0": "bu ay",
        "1": "gelecek ay",
        "future": {
          "one": "{0} ay sonra",
          "other": "{0} ay sonra"
        },
        "past": {
          "one": "{0} ay önce",
          "other": "{0} ay önce"
        }
      },
      "month-short": {
        "-1": "geçen ay",
        "0": "bu ay",
        "1": "gelecek ay",
        "future": {
          "one": "{0} ay sonra",
          "other": "{0} ay sonra"
        },
        "past": {
          "one": "{0} ay önce",
          "other": "{0} ay önce"
        }
      },
      "nu": ["latn"],
      "quarter": {
        "-1": "geçen çeyrek",
        "0": "bu çeyrek",
        "1": "gelecek çeyrek",
        "future": {
          "one": "{0} çeyrek sonra",
          "other": "{0} çeyrek sonra"
        },
        "past": {
          "one": "{0} çeyrek önce",
          "other": "{0} çeyrek önce"
        }
      },
      "quarter-narrow": {
        "-1": "geçen çyr.",
        "0": "bu çyr.",
        "1": "gelecek çyr.",
        "future": {
          "one": "{0} çyr. sonra",
          "other": "{0} çyr. sonra"
        },
        "past": {
          "one": "{0} çyr. önce",
          "other": "{0} çyr. önce"
        }
      },
      "quarter-short": {
        "-1": "geçen çyr.",
        "0": "bu çyr.",
        "1": "gelecek çyr.",
        "future": {
          "one": "{0} çyr. sonra",
          "other": "{0} çyr. sonra"
        },
        "past": {
          "one": "{0} çyr. önce",
          "other": "{0} çyr. önce"
        }
      },
      "second": {
        "0": "şimdi",
        "future": {
          "one": "{0} saniye sonra",
          "other": "{0} saniye sonra"
        },
        "past": {
          "one": "{0} saniye önce",
          "other": "{0} saniye önce"
        }
      },
      "second-narrow": {
        "0": "şimdi",
        "future": {
          "one": "{0} sn. sonra",
          "other": "{0} sn. sonra"
        },
        "past": {
          "one": "{0} sn. önce",
          "other": "{0} sn. önce"
        }
      },
      "second-short": {
        "0": "şimdi",
        "future": {
          "one": "{0} sn. sonra",
          "other": "{0} sn. sonra"
        },
        "past": {
          "one": "{0} sn. önce",
          "other": "{0} sn. önce"
        }
      },
      "week": {
        "-1": "geçen hafta",
        "0": "bu hafta",
        "1": "gelecek hafta",
        "future": {
          "one": "{0} hafta sonra",
          "other": "{0} hafta sonra"
        },
        "past": {
          "one": "{0} hafta önce",
          "other": "{0} hafta önce"
        }
      },
      "week-narrow": {
        "-1": "geçen hf.",
        "0": "bu hf.",
        "1": "gelecek hf.",
        "future": {
          "one": "{0} hf. sonra",
          "other": "{0} hf. sonra"
        },
        "past": {
          "one": "{0} hf. önce",
          "other": "{0} hf. önce"
        }
      },
      "week-short": {
        "-1": "geçen hf.",
        "0": "bu hf.",
        "1": "gelecek hf.",
        "future": {
          "one": "{0} hf. sonra",
          "other": "{0} hf. sonra"
        },
        "past": {
          "one": "{0} hf. önce",
          "other": "{0} hf. önce"
        }
      },
      "year": {
        "-1": "geçen yıl",
        "0": "bu yıl",
        "1": "gelecek yıl",
        "future": {
          "one": "{0} yıl sonra",
          "other": "{0} yıl sonra"
        },
        "past": {
          "one": "{0} yıl önce",
          "other": "{0} yıl önce"
        }
      },
      "year-narrow": {
        "-1": "geçen yıl",
        "0": "bu yıl",
        "1": "gelecek yıl",
        "future": {
          "one": "{0} yıl sonra",
          "other": "{0} yıl sonra"
        },
        "past": {
          "one": "{0} yıl önce",
          "other": "{0} yıl önce"
        }
      },
      "year-short": {
        "-1": "geçen yıl",
        "0": "bu yıl",
        "1": "gelecek yıl",
        "future": {
          "one": "{0} yıl sonra",
          "other": "{0} yıl sonra"
        },
        "past": {
          "one": "{0} yıl önce",
          "other": "{0} yıl önce"
        }
      }
    },
    "locale": "tr-CY"
  });
}